import React from 'react';

export default ({ color = '#8E95AA', size = 19 }) => (
  <svg width={size} height={size} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5581 9.49974H16.3081M11.281 10.5289L15.3977 12.9039M10.5289 11.281L12.9039 15.3977M9.49974 11.5581V16.3081M8.47057 11.281L6.09557 15.3977M7.71849 10.5289L3.60182 12.9039M7.44141 9.49974H2.69141M7.71849 8.47057L3.60182 6.09557M8.47057 7.71849L6.09557 3.60182M9.49974 7.44141V2.69141M10.5289 7.71849L12.9039 3.60182M11.281 8.47057L15.3977 6.09557"
      stroke={color}
      strokeWidth="1.26667"
      strokeLinecap="round"
    />
  </svg>
);
